import React from "react";
import { LIVE } from "../../data";
import { trackTelegramClick } from "../../lib/tracking";
import { ArrowRight, CalendarDays, Lock, Play, ShieldCheck } from "lucide-react";

const FEATURES = [
  { icon: CalendarDays, text: "Disponibilità ogni Lunedì fino a Dicembre 2026" },
  { icon: Lock, text: "Canale Privato" },
  { icon: ShieldCheck, text: "Selezione all'ingresso" },
];

export default function LiveSession() {
  const TELEGRAM_URL = "https://t.me/+T9sPHsLExsUxOTFk";

  return (
    <section id="live" data-testid="free-trial-section" className="sec relative overflow-hidden" style={{ background: "#00030F", borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)" }}>
      <div aria-hidden className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full" style={{ width: 640, height: 640, background: "radial-gradient(circle, rgba(46,107,255,0.18) 0%, rgba(46,107,255,0) 65%)" }} />
      <div className="relative mx-auto max-w-[920px] px-4 text-center lg:max-w-[1440px] lg:px-12 lg:grid lg:grid-cols-2 lg:gap-x-20 lg:items-center lg:text-left">
        <div className="lg:col-start-1 lg:row-start-1 lg:min-w-0">
        <div className="numhead lg:!justify-start" style={{ justifyContent: "center" }}>
          <span className="numchip">{LIVE.index}</span>
        </div>

        <h2 className="mt-8 free-h2" style={{ fontWeight: 800, lineHeight: 1.05, letterSpacing: "-0.02em", color: "#fff" }}>
          Prova <span style={{ color: "#4E85FF" }}>GRATUITAMENTE</span>
        </h2>
        <p data-testid="free-trial-subtitle" className="mt-6 mx-auto max-w-[62ch] lg:mx-0" style={{ fontSize: "clamp(1.02rem, 2vw, 1.2rem)", lineHeight: 1.6 }}>
          Tocca con mano il livello e la qualità. Se ti piace, sali a bordo. Se non ti piace, fine.
        </p>

        <ul className="mt-12 grid gap-6 sm:grid-cols-3 lg:grid-cols-1 lg:gap-5" style={{ listStyle: "none", padding: 0 }}>
          {FEATURES.map(({ icon: Icon, text }, i) => (
            <li key={text} data-testid={`free-trial-feature-${i}`} className="flex flex-col items-center gap-3 px-2 lg:flex-row lg:gap-4 lg:px-0">
              <span className="flex items-center justify-center rounded-full" style={{ width: 52, height: 52, border: "1px solid rgba(78,133,255,0.45)", background: "rgba(46,107,255,0.08)" }}>
                <Icon size={22} strokeWidth={1.6} style={{ color: "#4E85FF" }} />
              </span>
              <span style={{ fontSize: "0.98rem", fontWeight: 600, color: "#fff", maxWidth: "22ch" }} className="lg:!max-w-none">{text}</span>
            </li>
          ))}
        </ul>
        </div>

        <div className="lg:col-start-2 lg:row-start-1 lg:row-span-2 lg:flex lg:flex-col lg:items-center lg:gap-6">

        <div className="mt-12 flex justify-center lg:mt-0 lg:w-full">
          <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackTelegramClick("vsl_sezione08_immagine")} data-testid="free-trial-channel-preview" className="block w-full max-w-[460px] overflow-hidden rounded-2xl transition-transform duration-300 hover:-translate-y-1" style={{ border: "1px solid rgba(78,133,255,0.3)", boxShadow: "0 20px 50px rgba(0,0,0,0.5)" }}>
            <img src="/img/telegram-channel.webp" alt="Canale Telegram HighTicketSales.it: 38 iscritti e 8 richieste di accesso" loading="lazy" className="block w-full h-auto" />
          </a>
        </div>

        <div className="mt-10 flex justify-center lg:mt-0 lg:shrink-0">
          <a href="https://www.instagram.com/7figuresalesrep/reel/Del5a8CsCpS/" target="_blank" rel="noopener noreferrer" data-testid="free-trial-reel-card" className="group relative block w-[220px] sm:w-[260px] lg:w-[250px] overflow-hidden rounded-[16px]" style={{ border: "1px solid var(--line)", background: "#05070F", aspectRatio: "9/16" }}>
            <img src="/assets/26ff645b9e43.webp" alt="Reel Instagram HighTicketSales — Era già un pochino che ti osservavo" loading="lazy" className="h-full w-full object-cover transition duration-300 group-hover:scale-105" />
            <div className="pointer-events-none absolute inset-0 flex items-center justify-center" style={{ background: "linear-gradient(180deg, rgba(0,0,0,0.12) 0%, rgba(0,0,0,0.28) 100%)" }}>
              <span className="flex items-center justify-center rounded-full transition duration-300 group-hover:scale-110" style={{ width: 50, height: 50, background: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)", border: "1px solid rgba(255,255,255,0.45)" }}>
                <Play size={22} fill="#fff" className="text-white" style={{ marginLeft: 3 }} />
              </span>
            </div>
          </a>
        </div>
        </div>

        <div className="mt-10 flex justify-center lg:col-start-1 lg:row-start-2 lg:justify-start lg:self-start">
          <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackTelegramClick("vsl_sezione08_entra_ora")} data-testid="free-trial-cta" className="btn btn-blue btn-glow" style={{ fontSize: "1.2rem", padding: "20px 46px", minHeight: 64, borderRadius: 999, fontWeight: 700 }}>
            Entra Ora <ArrowRight size={20} />
          </a>
        </div>
      </div>
    </section>
  );
}
